import React from 'react';
import Locale from '../domain/Locale';
import StatusLucid from '../domain/StatusLucid';
import Footer from '../components/Footer';
import MarkdownComponent from '../components/MarkdownComponent'
import get_bundle from '../domain/get_bundle';
import { t, props } from 'tcomb-react';

@props({
  locale: Locale,
  callback: t.Function,
  status: t.maybe(StatusLucid)
})
export default class LucidTutorial extends React.Component {

  
  scrollTop() {
    window.scrollTo(0, 0);
  }

  componentDidMount () {
    this.scrollTop();
  }

  doContinue = (evt) => {
    evt.preventDefault();
    this.props.callback(true);
  }

  getContentKo = () => {
    const bundle = get_bundle(this.props.locale).lucid;
    const style = {
      maxWidth: this.props.width
    };
    return (
      <div className='web-modal'>
        <div className='modal-body' style={style}>
          <div className='modal-header'>
            <h1>{bundle.popupKO.title}</h1>
          </div>
          <div className='modal-section'>
            <MarkdownComponent>
              {bundle.popupKO.msg}
            </MarkdownComponent>
          </div>
          <div className='modal-footer'>
            <button onClick={this.doContinue}>{bundle.btn}</button>
          </div>
        </div>
      </div>
    )
  }

  getContentOk = () => {
    const bundle = get_bundle(this.props.locale).lucid;
    const style = {
      maxWidth: this.props.width
    };
    return (
      <div className='web-modal'>
        <div className='modal-body' style={style}>
          <div className='modal-header'>
            <h1>{bundle.popupOK.title}</h1>
          </div>
          <div className='modal-section'>
            <MarkdownComponent>
              {bundle.popupOK.msg}
            </MarkdownComponent>
          </div>
          <div className='modal-footer'>
            <button onClick={this.doContinue}>{bundle.btn}</button>
          </div>
        </div>
      </div>
    )
  }

  getContent = () => {
    if (this.props.status === 'ok') {
      return this.getContentOk()
    } 
    if (this.props.status === 'ko') {
      return this.getContentKo()
    }
  }

  render() {
    return (
      <div>
        <div className='overlay'></div>
        {this.getContent()}
      </div>
    );
  }
}




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/LucidTutorial.js
 **/